export default function () {
    return (
        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3.375" y="9.5" width="23.625" height="15.75" rx="1.6875" stroke="black" strokeWidth="1.6875" />
            <path
                d="M6.75 21.875V14C6.75 13.3787 7.25368 12.875 7.875 12.875H9C9.62132 12.875 10.125 13.3787 10.125 14V20.75C10.125 21.3713 10.6287 21.875 11.25 21.875H12.375C12.9963 21.875 13.5 21.3713 13.5 20.75V14C13.5 13.3787 14.0037 12.875 14.625 12.875H15.75C16.3713 12.875 16.875 13.3787 16.875 14V20.75C16.875 21.3713 17.3787 21.875 18 21.875H19.125C19.7463 21.875 20.25 21.3713 20.25 20.75V14C20.25 13.3787 20.7537 12.875 21.375 12.875H22.5C23.1213 12.875 23.625 13.3787 23.625 14V21.875"
                stroke="black"
                strokeWidth="1.6875"
                strokeLinecap="round"
            />
            <path
                d="M7.875 24.575V27.5C7.875 28.1213 8.37868 28.625 9 28.625H29.8125C30.4338 28.625 30.9375 28.1213 30.9375 27.5V18.5"
                stroke="black"
                strokeWidth="1.6875"
            />
            <rect x="28.6875" y="10.0625" width="4.5" height="7.875" rx="0.5625" fill="black" stroke="black" strokeWidth="1.125" />
            <path
                d="M31.7812 12.5938C31.7812 13.0597 31.4035 13.4375 30.9375 13.4375C30.4715 13.4375 30.0938 13.0597 30.0938 12.5938C30.0938 12.1278 30.4715 11.75 30.9375 11.75C31.4035 11.75 31.7812 12.1278 31.7812 12.5938Z"
                fill="white"
            />
            <circle cx="30.9375" cy="15.6875" r="0.5625" fill="white" />
        </svg>
    );
}
